module.exports = __webpack_public_path__ + "static/img/科技.cd5e6a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/assets/科技.png
// module id = fsgX
// module chunks = 3